(function () {
  document.querySelectorAll('script[id^="HobCountedIds-"]').forEach(function (source) {
    if (source.dataset.ready) return;
    source.dataset.ready = 'true';
    var sectionId = source.id.slice('HobCountedIds-'.length);
    var json = document.getElementById('ProductJson-' + sectionId);
    var form = document.getElementById('AddToCartForm--' + sectionId);
    if (!json || !form) return;
    var ids = new Set(JSON.parse(source.textContent).filter(Boolean));
    var product = JSON.parse(json.textContent);
    product.variants = product.variants.filter(function (v) { return ids.has(String(v.id)); });
    json.textContent = JSON.stringify(product);
    var controls = Array.from(form.querySelectorAll('.single-option-selector__radio'));
    var keys = Array.from(new Set(controls.map(function (el) { return el.dataset.index; }))).sort();
    function normalize() {
      var selected = {};
      keys.forEach(function (key) {
        var group = controls.filter(function (el) { return el.dataset.index === key; });
        var eligible = product.variants.filter(function (v) {
          return Object.keys(selected).every(function (k) { return v[k] === selected[k]; });
        });
        var values = new Set(eligible.map(function (v) { return v[key]; }));
        var chosen;
        group.forEach(function (el) {
          if (el.tagName === 'SELECT') {
            Array.from(el.options).forEach(function (option) {
              option.hidden = !values.has(option.value);
              option.disabled = option.hidden;
            });
            if (!values.has(el.value)) el.value = values.values().next().value || '';
            chosen = el.value;
          } else {
            el.hidden = !values.has(el.value);
            el.disabled = el.hidden;
            el.style.display = el.hidden ? 'none' : ''; 
            Array.from(form.querySelectorAll('label')).forEach(function (label) {
              if (label.htmlFor === el.id) { label.hidden = el.hidden; label.style.display = el.hidden ? 'none' : ''; }
            });
            if (el.checked && !el.hidden) chosen = el.value;
            if (el.hidden) el.checked = false;
          }
        });
        if (chosen === undefined) {
          var first = group.find(function (el) { return !el.hidden; });
          if (first) { first.checked = true; chosen = first.value; }
        }
        if (chosen !== undefined) selected[key] = chosen;
      });
    }
    form.addEventListener('change', normalize, true);
    normalize();
  });
})();
